import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  timeout: 60000,
});

// Attach Pro license headers from localStorage so /breed and /chick-narrative
// (which depend on require_pro) succeed for unlocked users.
api.interceptors.request.use((config) => {
  try {
    const raw = localStorage.getItem("budgie_pro_v1");
    if (raw) {
      const v = JSON.parse(raw);
      if (v?.email && v?.license_key) {
        config.headers["X-License-Email"] = v.email;
        config.headers["X-License-Key"] = v.license_key;
      }
    }
  } catch {
    /* ignore */
  }
  return config;
});

export const fetchMutations = async () => (await api.get("/mutations")).data.mutations;
export const fetchMutation = async (id) => (await api.get(`/mutations/${id}`)).data;
export const fetchLoci = async () => (await api.get("/loci")).data.loci;
export const breed = async (payload) => (await api.post("/breed", payload)).data;
export const chickNarrative = async (payload) =>
  (await api.post("/chick-narrative", payload)).data;

export const createCheckout = async (email, origin_url, gift = null) =>
  (await api.post("/checkout/create", { email, origin_url, ...(gift ? { gift } : {}) })).data;

export const checkoutStatus = async (session_id) =>
  (await api.get(`/checkout/status/${session_id}`)).data;

export const shareByEmail = async (payload) =>
  (await api.post("/share/email", payload)).data;

export const resendLicense = async (email) =>
  (await api.post("/license/resend", { email })).data;

export const trackTrendingPair = async (m, f) =>
  (await api.post("/trending/track", { m, f })).data;

export const fetchTrendingPairs = async (limit = 5) =>
  (await api.get(`/trending/pairs?limit=${limit}`)).data.pairs;

// --- Image generation -------------------------------------------------------
// Encyclopedia: public per-mutation portrait (cached server-side forever).
export const mutationPhotoUrl = (mutationId) =>
  `${API}/mutation-photo/${encodeURIComponent(mutationId)}`;

// Pro-only on-demand portraits. Returns an Object URL (blob:) that can be
// dropped straight into <img src>. License headers are attached by the
// axios interceptor above.
export const fetchBudgiePortrait = async ({ descriptor, kind }) => {
  const resp = await api.post(
    "/budgie-portrait",
    { descriptor, kind },
    { responseType: "blob" }
  );
  return URL.createObjectURL(resp.data);
};

// --- Per-user phenotype photos (Pro only) ----------------------------------
// Public URL — token (public_id) is unguessable so no auth required.
export const userPhotoUrl = (publicId) =>
  `${API}/user-photos/i/${encodeURIComponent(publicId)}.jpg`;

export const listUserPhotos = async () =>
  (await api.get("/user-photos")).data.photos;

export const uploadUserPhoto = async (phenotypeKey, file) => {
  const fd = new FormData();
  fd.append("file", file);
  return (
    await api.post(
      `/user-photos/${encodeURIComponent(phenotypeKey)}`,
      fd,
      { headers: { "Content-Type": "multipart/form-data" } }
    )
  ).data;
};

export const deleteUserPhoto = async (phenotypeKey) =>
  (await api.delete(`/user-photos/${encodeURIComponent(phenotypeKey)}`)).data;

